import { CodeBook } from "@king-ict/eupisi-ui/models";
import { axiosBaseQuery } from "@king-ict/eupisi-ui/utils";
import { createApi } from "@reduxjs/toolkit/query/react";

import { Form7InstitutionsRequest } from "../api/Request/RequestApi";
import { SaveResult } from "../models";
import { Question } from "../models/Questionnaire/Question";
import {
  QuestionnaireResponse,
  RegistrationFormDataChangeDto,
  PersonDetailsWithNullPerson,
} from "../models/Request";

const requestUrlPrefix: string = "request";

export const requestApi = createApi({
  reducerPath: "requestApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Request"],
  endpoints: (build) => ({
    getForm7Institutions: build.query<
      CodeBook[],
      Form7InstitutionsRequest | undefined
    >({
      query: (request) => ({
        url: `${requestUrlPrefix}/get-form7-institutions`,
        method: "post",
        data: request,
      }),
    }),
    getRegistrationFormDataChange: build.query<
      RegistrationFormDataChangeDto,
      number
    >({
      query: (requestId) => ({
        url: `${requestUrlPrefix}/registrationFormDataChange/${requestId}`,
        method: "get",
      }),
      providesTags: ["Request"],
    }),
    saveRegistrationFormDataChange: build.mutation<
      SaveResult<RegistrationFormDataChangeDto>,
      { requestId: number; data: RegistrationFormDataChangeDto }
    >({
      query: ({ requestId, data }) => ({
        url: `${requestUrlPrefix}/save-registrationFormDataChange/${requestId}`,
        method: "post",
        data,
      }),
      invalidatesTags: ["Request"],
    }),
    getQuestionnaireQuestions: build.query<Question[], void>({
      query: () => ({
        url: `${requestUrlPrefix}/questionnaire-registration-form-data-change`,
        method: "get",
      }),
      transformResponse: (response: QuestionnaireResponse) =>
        response.questionGroups.flatMap((group) => group.questions),
    }),
    getPersonDetailsByOib: build.query<PersonDetailsWithNullPerson, string>({
      query: (oib) => ({
        url: `${requestUrlPrefix}/personDetails/oib-service/${oib}`,
        method: "get",
      }),
    }),
    deleteRegistrationForm: build.mutation<void, number>({
      query: (requestId) => ({
        url: `${requestUrlPrefix}/delete-registrationForm/${requestId}`,
        method: "post",
      }),
      invalidatesTags: ["Request"],
    }),
  }),
});

export const {
  useGetForm7InstitutionsQuery,
  useGetRegistrationFormDataChangeQuery,
  useSaveRegistrationFormDataChangeMutation,
  useGetQuestionnaireQuestionsQuery,
  useGetPersonDetailsByOibQuery,
  useLazyGetPersonDetailsByOibQuery,
  useDeleteRegistrationFormMutation,
} = requestApi;
